const DEFAULT_SLIDE_DURATION = 10000;
export const initStageSlider = () => {
    const stageSlider = document.querySelector('.m-stage__slider');
    if (!stageSlider) {
        return;
    }
    const slides = stageSlider.querySelectorAll('.m-stage__slider-item');
    if (slides.length === 0) {
        return;
    }
    const previousSlideButton = stageSlider.querySelector('.m-stage__slider-previous');
    const nextSlideButton = stageSlider.querySelector('.m-stage__slider-next');
    const slideDuration = stageSlider.dataset.slideDuration
        ? parseInt(stageSlider.dataset.slideDuration)
        : DEFAULT_SLIDE_DURATION;
    let activeSlideIndex = 0;
    let showNextSlideTimeout = undefined;
    const useTimeout = () => {
        if (!showNextSlideTimeout) {
            return false;
        }
        window.clearTimeout(showNextSlideTimeout);
        showNextSlideTimeout = undefined;
        showNextSlideTimeout = window.setTimeout(showNextSlide, slideDuration);
        return true;
    };
    const showActiveSlide = () => {
        slides.forEach((slide, index) => slide.classList.toggle('active', index === activeSlideIndex));
    };
    const showPreviousSlide = () => {
        if (!useTimeout()) {
            return;
        }
        if (activeSlideIndex == 0) {
            activeSlideIndex = slides.length;
        }
        else if (activeSlideIndex < 0) {
            activeSlideIndex = 1;
        }
        activeSlideIndex--;
        showActiveSlide();
    };
    const showNextSlide = () => {
        if (!useTimeout()) {
            return;
        }
        activeSlideIndex++;
        if (activeSlideIndex >= slides.length) {
            activeSlideIndex = 0;
        }
        showActiveSlide();
    };
    previousSlideButton?.addEventListener('click', (event) => {
        event.preventDefault();
        showPreviousSlide();
    });
    nextSlideButton?.addEventListener('click', (event) => {
        event.preventDefault();
        showNextSlide();
    });
    showNextSlideTimeout = window.setTimeout(showNextSlide, slideDuration);
};
